export default "/images/outline.svg?a4fa7abbda5a616a3926fdeb84f207b0";